import { ChangeDetectorRef,Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/shared/services/webapi.service';
declare var bootstrap;
declare var $: any;

@Component({
  selector: 'app-playlist-videos',
  templateUrl: './playlist-videos.component.html',
  styleUrls: ['./playlist-videos.component.scss']
})
export class PlaylistVideosComponent implements OnInit,OnChanges   {
  @Input() modalid:any;
  @Input() type ="playlist";
  @Input() reinit =1;
  @Input() selectedPlaylist:any;
  user:any;
  page=1
  keyword=''
  noVideos=false;
  totalvideo = 0;
  videosListAll: any = [];
  videosList: any = [];
  videoDetails: any;
  currentIndex = 8;
  items=[];
  filterVideos = [];
  initilised=false;

  constructor(public webApi: WebapiService,public cdr: ChangeDetectorRef, public router: Router, private toastrService: ToastrService) {
  }

  addItem(newItem:any) {
    this.videoDetails = newItem;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName == "reinit") {
        this.initilised=true;
        this.videosList=[];
        this.getVideos()
      }
    }
    // changes.prop contains the old and the new value...
  }

  ngOnInit()  
  {    
    if(!this.initilised){
      this.getVideos()
    }
    //this.getVideos()
  } 

  // updateOnlyOnBlur(event) {
  //   this.page=1;
  //   this.videosList = [];
  //   this.getVideos()
  // }

  updateOnlyOnBlur(event) {
    this.currentIndex = 8;
    this.items = [];
    this.filterVideos = this.videosListAll.filter((item)=> { 
      return (item.name.toLowerCase().indexOf(this.keyword) >= 0) 
    })

    this.items = this.filterVideos.slice(0, this.currentIndex);
    this.videosList = this.filterVideos;

    if(this.keyword.length==0){
      this.videosList = this.videosListAll
    }
  }
  
  getVideos(){
    console.log('herer');
    this.noVideos = false;
    this.webApi.setLoader(true);
    let params= {
      "keyword":this.keyword,
      "playlist_id":this.selectedPlaylist,
      "page":this.page
    }
    this.webApi.getPlaylistVideos(params).subscribe((video: any) => {
      this.videosList = [...this.videosList,...video.videos]; 
      this.videosListAll = [...this.videosListAll,...video.videos]; 
      if(this.videosListAll.length==0){
        this.noVideos = true;
      }
      this.items = this.videosListAll.slice(0, this.currentIndex);
      this.totalvideo = video.total; 
      this.webApi.setLoader(false);
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  LoadMoreLocal(){
    this.currentIndex += 8;
    if(this.keyword.length>0){
      if(this.filterVideos.length-1<this.currentIndex){
        this.currentIndex = this.filterVideos.length
      }
    }else{
      if(this.videosListAll.length-1<this.currentIndex){
        this.currentIndex = this.videosListAll.length
      }
    }
    
    this.items = this.videosListAll.slice(0, this.currentIndex);
    this.cdr.detectChanges();
  }

  showMore() {
    this.page = this.page+1
    this.getVideos();
  }

}
